import { useSyncExternalStore } from "react";
import { useTheme } from "@/theme/theme-provider";

const query = "(prefers-color-scheme: dark)";
const subscribe = (onChange: () => void) => {
  const mq = window.matchMedia(query);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
};

export const useIsDarkMode = () => {
  const { theme } = useTheme();
  // No media query on the server: render light there and during hydration, then React re-renders with the real value.
  const prefersDark = useSyncExternalStore(subscribe, () => window.matchMedia(query).matches, () => false);
  if (theme === "system") {
    return prefersDark;
  }
  return theme === "dark";
};
